import { Card } from "react-bootstrap";
import { Button } from "./Button";
import { getStateEnumFromCode, showStateName } from "../Data/UsState";
import { Vehicle, VehicleSubscriptionSummary } from "../Data/ApiTypes";
import { CarFront, Tag, Trash } from "react-bootstrap-icons";

export interface VehicleCardProps {
    vehicle:       Vehicle;
    vehicles:      Vehicle[];
    deleteVehicle: ( vehicle: Vehicle ) => void;
    disabled?:     boolean;
    /** Account vehicles page. Checkout omits this and keeps the labeled Remove button. */
    subscriptions?: VehicleSubscriptionSummary[];
    onAssign?:     () => void;
    onUnlink?:     ( subscription: VehicleSubscriptionSummary ) => void;
}

function isDefined( value: string | undefined | null){
    return value !== 'N/A' && value !== undefined && value !== null;
}

function VehicleMark( { vehicle }: { vehicle: Vehicle } ) {
    return isDefined( vehicle.color ) ? (
        <div className="rounded-2 border border-secondary me-2"
            style={{ height: "32px", width: "32px", backgroundColor: vehicle.color }} />
    ) : (
        <CarFront className="text-secondary mx-2" size={20} />
    );
}

function plateLine( vehicle: Vehicle ) {
    const state = showStateName( getStateEnumFromCode( vehicle.stateCode )! );
    return `${state ? state + " · " : ""}${vehicle.licensePlateNumber}`;
}

export function VehicleCard( { vehicle, deleteVehicle, disabled = false, subscriptions, onAssign, onUnlink }: VehicleCardProps ) {
    if( subscriptions !== undefined ) {
        const onPlan = subscriptions.length > 0;
        return <Card className="mb-2">
            <Card.Body>
                <div className="d-flex align-items-start gap-2">
                    <VehicleMark vehicle={vehicle} />
                    <div className="flex-grow-1 min-w-0">
                        {isDefined( vehicle.make ) && (
                            <div className="fw-bold">{vehicle.make} {vehicle.model}</div>
                        )}
                        <div className="text-secondary small">{plateLine( vehicle )}</div>
                    </div>
                    {!disabled && (
                        <button type="button"
                                className="btn btn-link text-secondary p-1 align-self-start"
                                aria-label="Remove vehicle"
                                onClick={() => deleteVehicle( vehicle )}>
                            <Trash />
                        </button>
                    )}
                </div>
                {onPlan ? (
                    <div className="d-flex flex-column gap-1 mt-2">
                        {subscriptions.map( s =>
                            <span key={s.subscriptionId}
                                  className="d-flex align-items-center gap-2 px-2 py-1 w-100"
                                  style={{ background: "#FDE8F3", color: "#C43B7A", borderRadius: 6 }}>
                                <Tag size={10} className="flex-shrink-0" />
                                <span className="d-flex flex-column lh-sm flex-grow-1 min-w-0">
                                    <span className="small fw-semibold">{s.planName}</span>
                                    <span className="fw-normal" style={{ fontSize: "0.7rem", opacity: 0.7 }}>{s.facilityName}</span>
                                </span>
                                {onUnlink && (
                                    <button type="button"
                                            className="btn btn-link btn-sm p-0 fw-semibold text-decoration-none flex-shrink-0"
                                            style={{ color: "#C43B7A" }}
                                            onClick={() => onUnlink( s )}>
                                        Unlink
                                    </button>
                                )}
                            </span>
                        )}
                    </div>
                ) : (
                    <div className="d-flex align-items-center justify-content-between gap-2 mt-2 px-2 py-1 w-100"
                         style={{ border: "1px dashed #ced4da", borderRadius: "0.75rem" }}>
                        <span className="text-secondary small">Not on a subscription</span>
                        {onAssign && (
                            <button type="button"
                                    className="btn btn-link btn-sm p-0 fw-semibold text-decoration-none"
                                    style={{ color: "#FC5EB4" }}
                                    onClick={onAssign}>
                                Assign
                            </button>
                        )}
                    </div>
                )}
            </Card.Body>
        </Card>;
    }

    return <Card className="mb-2">
        <Card.Body className="gap-1"
            style={{
                display: "grid",
                alignItems: "center", /* color make model */
                gridTemplateColumns: "min-content 1fr auto"
            }}>
            {isDefined(vehicle.color) ? (
                <div className="rounded-2 border border-secondary me-2"
                    style={{ height: "32px", width: "32px", backgroundColor: vehicle.color }} />
            ) : (             
                   <CarFront className="text-secondary mx-2" size={20} />        
            )}
            <div style={{ display: "grid", alignItems: "center", gridTemplateRows: "auto auto" }}>
                {isDefined(vehicle.make) && (
                <div className="fw-bold d-flex flex-column gap-1">
                    {vehicle.make} {vehicle.model}
                </div>
                )}
                <div>
                    {showStateName( getStateEnumFromCode( vehicle.stateCode )! )} {vehicle.licensePlateNumber}
                </div>
            </div>
            {!disabled && <div className="w-100">
                <Button size="sm" onClick={() => deleteVehicle( vehicle )}>
                    <Trash className="me-1" style={{ marginTop: "-5px" }} />
                    Remove
                </Button>
            </div>}
        </Card.Body>
    </Card>;
}
